export const lobbyPlayers = [
  {
    username: "Pondorasti",
    gamerTag: "Lascorpy",
    avatarUrl: "https://avatars0.githubusercontent.com/u/32957606?s=460&u=e631c3762c12d41f3ce0348b8137f0751a2eed75&v=4",
    bio: "we only allow this many characters? 52 chars, let's make it 62",
    isHost: true,
    isAccepted: true,
  },
  {
    username: "SenpaiSam",
    gamerTag: "senpaisamurman",
    avatarUrl: "https://static-cdn.jtvnw.net/jtv_user_pictures/8511f248-3eff-4338-a9f1-677b7cb11fae-profile_image-150x150.png",
    bio: "sometimes i feel like having fun and sometimes i feel like crying and sometimes i just don't know.",
  },
  {
    username: "Jeremiah",
    gamerTag: "itsScoopy",
    avatarUrl: "https://static-cdn.jtvnw.net/jtv_user_pictures/d29303bd-94f1-458d-8693-e178a2398bb9-profile_image-300x300.png",
    bio: "Software engineer in the making; Into fitness and video games;Couldn't catch a tan if I tried;",
  },
  {
    username: "Pondorasti",
    gamerTag: "Lascorpy",
    avatarUrl: "https://avatars0.githubusercontent.com/u/32957606?s=460&u=e631c3762c12d41f3ce0348b8137f0751a2eed75&v=4",
    bio: "we only allow this many characters? 52 chars, let's make it 62",
  },
  {
    username: "Pondorasti",
    gamerTag: "Lascorpy",
    avatarUrl: "https://avatars0.githubusercontent.com/u/32957606?s=460&u=e631c3762c12d41f3ce0348b8137f0751a2eed75&v=4",
    bio: "we only allow this many characters? 52 chars, let's make it 62",
  }
]

export default lobbyPlayers